(function () {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('BBPSSettings', BBPSSettings);

    BBPSSettings.$inject = ['$resource'];

    function BBPSSettings($resource) {
        var resourceUrl = 'api/bbps-settings/:id';
        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                params: { id: '@id' },
                url: 'api/bbps-settings/:id',
                transformResponse: function (data) {
                    if (data) {
                        return angular.fromJson(data);
                    }
                    return data;
                }
            },

            'update': {
                method: 'POST',
                params: { orgId: '@orgId' },
                url: 'api/bbps-settings/orgId/:orgId',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                }
            },
            'approve': {
                method: 'GET',
                params: { taskId: '@taskId' },
                url: 'api/tasks/:taskId/approve'
            },
            'reject': {
                method: 'GET',
                params: { taskId: '@taskId' },
                url: 'api/tasks/:taskId/reject'
            },
            'discard': {
                method: 'GET',
                params: { taskId: '@taskId' },
                url: 'api/tasks/:taskId/discard'
            },
            'resubmit': {
                method: 'PUT',
                params: { taskId: '@taskId' },
                url: 'api/tasks/:taskId/resubmit/bbps-settings',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                }
            },
            'getBBPSSettings': {
                method: 'GET',
                isArray: true,
                params: { bankId: '@bankId',currentAndPreviousDaySettings :'@currentAndPreviousDaySettings'},
                url: 'api/bbps-settings/bank/:bankId/:currentAndPreviousDaySettings',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            //   'getBBPSSetting': {
            //       method: 'GET',
            //       isArray: true,
            //       params: {branchId:'@branchId',bankId:'@bankId'},
            //       url: 'api/markup-for-customer/customer/:customerId',
            //       transformResponse: function (data) {
            //           if (data) {
            //               data = angular.fromJson(data);
            //           }
            //           return data;
            //       }
            //   }

        });
    }
})();
